import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V_Detail = {
  '@id': string;
  '@type': 'UserQuestionnaire';
  id: string;
  type: string;
  responses: Array<object>;
};

export type V_List = {
  '@id': string;
  '@type': 'UserQuestionnaire';
  id: string;
  type: string;
};

export type W = {
  responses: Array<object>;
};

export function useReadCollection(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_List>>(`/my-questionnaires`, options);
}

export function useReadItemQuestionnairesType(
  id: string,
  type: string,
  options?: ReadConfig,
) {
  return useApiRead<V_Detail>(`/users/${id}/questionnaires/${type}`, options);
}
